<template>
  <h1>Produkt</h1>
  <form @submit.prevent="save" class="row ml-0 mr-0">

    <div class="input-group mb-3">
      <div class="input-group-prepend">
        <label class="input-group-text" for="name">Name</label>
      </div>
      <input v-model="form.name" class="form-control form-control-lg" id="name" placeholder="">
    </div>

    <div class="input-group mb-3">
      <div class="input-group-prepend">
        <label class="input-group-text" for="productType">Produktart</label>
      </div>
      <select
          v-model="form.type"
          class="custom-select custom-select-lg" id="type"
          required>
        <option>Auswählen..</option>
        <option value="1">Ölkürbis</option>
        <option value="2">Weizen</option>
        <option value="3">Mais</option>
      </select>
    </div>

    <div class="col-3 ">
      <button @click="closeForm" type="reset">Abbrechen</button>
    </div>
    <div class="col-5">
      <button type="submit">Speichern</button>
    </div>
  </form>
</template>

<script>
export default {
  name: "ProductEditor",
  data() {
    return {
      form: {
        name: null,
        type: null,
      },
    }
  },
  props: {
    elementId: {
      type: Number,
      default: null
    },
  },
  created() {
    if (this.elementId) {
      this.$store.dispatch('getItem', {name: 'product', id: this.elementId})
          .then(this.loadData.bind(this))
    }
  },
  methods: {
    closeForm() {
      this.$emit('closeForm')
    },
    savedForm() {
      this.$emit('savedForm')
    },
    async save() {
      const response = await this.$store.dispatch('cruItem', {name: 'product', id: this.elementId, data: this.form})
      console.log('got response',response)
      if (response && response.success == true) {
        this.closeForm()
      }
    },
    loadData(entry) {
      console.log('got entry',entry)
      this.form = entry
    },
    toggleValueType() {
      this.valueType = this.valueType === 'b';
    }
      
  }
}
</script>

<style scoped>

</style>